export enum QueryKey {
  AUTH_ME_GET = 'AUTH_ME_GET',
  GET_REGIONS = 'GET_REGIONS',
  GET_CITIES = 'GET_CITIES',
  GET_VACANCIES = 'GET_VACANCIES',
  GET_SCHEDULE_WORK = 'GET_SCHEDULE_WORK',
  GET_EMPLOYMENT_TYPES = 'GET_EMPLOYMENT_TYPES',
  GET_SKILLS = 'GET_SKILLS',
  GET_PAYMENT_PERIODS = 'GET_PAYMENT_PERIODS',
  GET_CURRENCIES = 'GET_CURRENCIES',
  GET_USERS = 'GET_USERS',
  GET_COMPANY_TYPES = 'GET_COMPANY_TYPES',
  GET_COMPANY = 'GET_COMPANY',
  GET_ECONOMIC_ACTIVITIES = 'GET_ECONOMIC_ACTIVITIES',
  GET_ACTIVITY_SPHERE = 'GET_ACTIVITY_SPHERE',
  GET_USERS_WITH_PAGINATION = 'GET_USERS_WITH_PAGINATION',
  GET_USER = 'GET_USER',
  GET_VACANCY_STATUSES = 'GET_VACANCY_STATUSES',
  GET_VACANCY_TARIFFS = 'GET_VACANCY_TARIFFS',
  GET_VACANCY_TARIFFS_HISTORY = 'GET_VACANCY_TARIFFS_HISTORY',
  GET_VACANCY = 'GET_VACANCY',
  GET_VACANCY_STATUS_HISTORY = 'GET_VACANCY_STATUS_HISTORY',
  GET_VACANCIES_TEMPLATES = 'GET_VACANCIES_TEMPLATES',
  GET_VACANCIES_TEMPLATE = 'GET_VACANCIES_TEMPLATE',
  GET_USER_ROLES = 'GET_USER_ROLES',
  GET_VACANCY_CANDIDATES = 'GET_VACANCY_CANDIDATES',
  GET_VACANCY_CANDIDATES_PICK_DRAWER = 'GET_VACANCY_CANDIDATES_PICK_DRAWER',
  GET_VACANCY_DECISION_TYPES = 'GET_VACANCY_DECISION_TYPES',
  GET_VACANCY_REJECTED_REASONS = 'GET_VACANCY_REJECTED_REASONS',
  GET_CANDIDATES = 'GET_CANDIDATES',
  GET_CANDIDATE = 'GET_CANDIDATE',
  GET_COMPANY_REVIEWS = 'GET_COMPANY_REVIEWS',
  LIST_USER_AI_MESSAGES_SERVER_LATEST = 'LIST_USER_AI_MESSAGES_SERVER_LATEST',
  LIST_USER_AI_MESSAGES_SERVER_HISTORY = 'LIST_USER_AI_MESSAGES_SERVER_HISTORY',
  INDEX_QUICK_MESSAGES = 'INDEX_QUICK_MESSAGES',
  SHOW_SELECTED_CANDIDATE_VACANCY = 'SHOW_SELECTED_CANDIDATE_VACANCY',
  GET_VACANCIES_RATING = 'GET_VACANCIES_RATING',
  GET_INTERVIEW_CANCELLATION_REASONS = 'GET_INTERVIEW_CANCELLATION_REASONS',
  GET_CANDIDATE_REJECTION_REASONS = 'GET_CANDIDATE_REJECTION_REASONS',
  GET_EMPLOYMENT_REVIEW_QUESTIONS = 'GET_EMPLOYMENT_REVIEW_QUESTIONS',
}
